import React from 'react';
import StyledGrid from '../../styles/blocks/Grid/Grid';
const Grid = props => {
    const { children, id } = props;
    return (<StyledGrid {...(id ? { nativeID: id } : {})} dataSet={{ 'brighte-class': 'brighte-one-grid' }}>
      {children}
    </StyledGrid>);
};
export default Grid;
